/* LGB add-ons panel — generic engine.
   Driven entirely by window.LGBAddons, which a liquid snippet sets per range.
   Shows only the extras that genuinely apply to this building, matched to the
   size the customer has chosen. The first two rows show; the rest sit behind a
   "more options" line so the panel stays light on a phone.
   Nothing is ever pre-ticked. If anything at all fails, the page behaves
   exactly as it always has.

   19 Oct 2026 (A1 Garden Buildings panel) - optional row settings, all ignored by the
   existing Sovereign/Shedlands rows, which behave exactly as before:
     fixed:  "Opening window" - pick the accessory variant whose option value is this text,
             whatever the size. Tokens: {size} = chosen size, {a}/{b} = its first/second
             number in whole feet ("Partition ... - {b}ft gable"). No match = row hidden.
     by:     "Building" - first narrow the accessory's variants to the value of this option
             that appears in the building's title (CFG.productTitle; "A / B" values allow
             either), then match the size on the accessory's own Size option.
     qty:    { max: 20, unit: "per foot" } - adds a quantity picker; the price shown is the
             line total, so the running total and basket both see the right amount.
     unless: "gutter" - hide this row when that other row is showing.

   22 Oct 2026 (Power Sheds / Lifelong / LOJ / Beeston / Vista / Coppice panels) - more
   optional settings, again ignored by every older row:
     pick:   true - the customer chooses which version of the extra they want from a small
             drop-down inside the row (e.g. shelf length, paint type). Combine with
     within: "Gazebo M" or "{m}" - only offer the accessory's versions that carry this
             option value (tokens allowed).
     map:    { "Medium": "Gazebo M" } - fills the {m} token from the chosen size.
     Tokens {A}/{B} = the first/second part of the size as written ("6ft 4in").
     Buildings with no Size option (e.g. a garage priced by Width and Length) now work
     too: only rows with a fixed / within value that has no size token can show. */
(function () {
  var CFG = window.LGBAddons;
  if (!CFG || !CFG.productHandle || !CFG.rows || !CFG.rows.length) return;

  var VISIBLE = 2;
  var product = null, acc = {}, lastKey = null, busy = false, expanded = false;

  function money(c) {
    var d = (c % 100) ? 2 : 0;
    return '£' + (c / 100).toLocaleString('en-GB', { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function norm(s) {
    return (s || '').toLowerCase().replace(/\([^)]*\)/g, '').replace(/ft/g, '').replace(/in/g, '')
      .replace(/['"]/g, '').replace(/\s/g, '').replace(/[×*]/g, 'x');
  }
  function swap(s) {
    var p = norm(s).split('x');
    return p.length === 2 ? p[1] + 'x' + p[0] : norm(s);
  }
  function mainForm() { return document.querySelector('form[data-type="add-to-cart-form"]'); }
  function idInputOf(f) { return f ? f.querySelector('input[name="id"]') : null; }

  function sizeIndex(p) {
    var names = (p.options || []).map(function (o) {
      return (typeof o === 'string') ? o : ((o && o.name) || '');
    });
    /* Accepts "Size" or any name starting with it, e.g. "Size (length x gable end)". */
    for (var i = 0; i < names.length; i++) {
      if (/^size\b/i.test(names[i])) return i;
    }
    return -1;
  }

  function currentSize() {
    var inp = idInputOf(mainForm());
    if (!inp || !product) return null;
    var idx = sizeIndex(product);
    if (idx < 0) return '*';
    var vid = String(inp.value), found = null;
    product.variants.forEach(function (v) { if (String(v.id) === vid) found = v; });
    if (!found) return null;
    return [found.option1, found.option2, found.option3][idx] || null;
  }

  function optNames(p) {
    return (p.options || []).map(function (o) { return (typeof o === 'string') ? o : ((o && o.name) || ''); });
  }
  function optIdx(p, re) {
    var names = optNames(p);
    for (var i = 0; i < names.length; i++) if (re.test(names[i])) return i;
    return -1;
  }
  function valAt(v, i) { return [v.option1, v.option2, v.option3][i]; }
  function plain(s) { return String(s || '').toLowerCase().replace(/[–—]/g, '-').replace(/\s+/g, ' ').trim(); }
  function words(s) { return ' ' + String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim() + ' '; }

  /* "{b}ft gable" etc. from the chosen size; null when a token can't be filled */
  function fill(tpl, size, row) {
    var clean = String(size || '').replace(/\([^)]*\)/g, '').replace(/\s+/g, ' ').trim();
    if (clean === '*') clean = '';
    var parts = clean.split(/\s*[x×]\s*/i);
    function feet(t) { var m = /^(\d+)\s*ft$/i.exec(String(t || '').trim()); return m ? m[1] : null; }
    var a = parts.length === 2 ? feet(parts[0]) : null, b = parts.length === 2 ? feet(parts[1]) : null, bad = false;
    var A = parts.length === 2 ? parts[0] : null, B = parts.length === 2 ? parts[1] : null;
    var M = (row && row.map) ? (row.map[String(size || '').trim()] || null) : null;
    var out = String(tpl).replace(/\{(size|a|b|A|B|m)\}/g, function (m0, k) {
      var r = k === 'size' ? clean : k === 'a' ? a : k === 'b' ? b : k === 'A' ? A : k === 'B' ? B : M;
      if (!r) bad = true;
      return r || '';
    });
    return bad ? null : out;
  }

  /* the accessory option value named in the building's title (longest match wins) */
  function pickByTitle(p, optName) {
    var i = optIdx(p, new RegExp('^' + optName + '$', 'i'));
    if (i < 0) return null;
    var title = words(CFG.productTitle || ''), best = null, bestLen = 0, seen = {};
    p.variants.forEach(function (v) {
      var val = valAt(v, i);
      if (!val || seen[val]) return;
      seen[val] = 1;
      String(val).split('/').forEach(function (alt) {
        var w = words(alt);
        if (w.length > 2 && title.indexOf(w) > -1 && w.length > bestLen) { best = val; bestLen = w.length; }
      });
    });
    return best === null ? null : { idx: i, val: best };
  }

  /* Accessory products carry Size as their first option. Where a second option
     exists (roof tile colour), the first available variant of that size wins,
     which is the supplier's default. */
  var cands = {}, selVar = {};
  function hasVal(v, t) { return plain(v.option1) === t || plain(v.option2) === t || plain(v.option3) === t; }
  function matchFor(p, size, r) {
    if (!size || !p) return null;
    r = r || {};
    if (r.pick) {
      var list = [], within = null;
      if (r.within) { within = fill(r.within, size, r); if (!within) return null; within = plain(within); }
      p.variants.forEach(function (v) {
        if (v.available === false) return;
        if (within && !hasVal(v, within)) return;
        list.push(v);
      });
      if (!list.length) return null;
      cands[r.key] = { list: list, within: within };
      var chosen = null;
      list.forEach(function (v) { if (String(v.id) === String(selVar[r.key])) chosen = v; });
      return chosen || list[0];
    }
    if (r.fixed) {
      var target = fill(r.fixed, size, r);
      if (!target) return null;
      target = plain(target);
      var hit = null;
      p.variants.forEach(function (v) {
        if (hit || v.available === false) return;
        if (plain(v.option1) === target || plain(v.option2) === target || plain(v.option3) === target) hit = v;
      });
      return hit;
    }
    if (size === '*') return null;
    var by = null;
    if (r.by) { by = pickByTitle(p, r.by); if (!by) return null; }
    var si = r.by ? optIdx(p, /^size\b/i) : 0;
    if (si < 0) return null;
    var want = norm(size), alt = swap(size), exact = null, rev = null;
    p.variants.forEach(function (v) {
      if (v.available === false) return;
      if (by && valAt(v, by.idx) !== by.val) return;
      var n = norm(valAt(v, si));
      if (n === want && !exact) exact = v;
      else if (n === alt && !rev) rev = v;
    });
    return exact || rev;
  }

  var qtys = {};
  function qtyOf(r) { return r.qty ? Math.max(1, Math.min(r.qty.max || 1, qtys[r.key] || 1)) : 1; }

  function rowHtml(r, variant, size, folded) {
    var title = r.sizeInTitle ? r.title.replace('{size}', size) : r.title;
    var q = qtyOf(r), picker = '', note = r.note || '';
    if (r.pick && cands[r.key] && cands[r.key].list.length > 1) {
      var w = cands[r.key].within, po = '';
      cands[r.key].list.forEach(function (v) {
        var bits = [v.option1, v.option2, v.option3].filter(function (x) { return x && plain(x) !== w && x !== 'Default Title'; });
        po += '<option value="' + v.id + '"' + (v.id === variant.id ? ' selected' : '') + '>' + bits.join(' / ') + ' – ' + money(v.price) + '</option>';
      });
      picker = '<span class="lgb-adds__qty lgb-adds__pick"><label for="lgbAddsP_' + r.key + '">Choose</label>' +
        '<select id="lgbAddsP_' + r.key + '" data-pick="' + r.key + '">' + po + '</select></span>';
    }
    if (r.qty) {
      var opts = '';
      for (var i = 1; i <= (r.qty.max || 1); i++) opts += '<option value="' + i + '"' + (i === q ? ' selected' : '') + '>' + i + '</option>';
      picker += '<span class="lgb-adds__qty"><label for="lgbAddsQ_' + r.key + '">Qty</label>' +
        '<select id="lgbAddsQ_' + r.key + '" data-qty="' + r.key + '">' + opts + '</select></span>';
      note = money(variant.price) + ' ' + (r.qty.unit || 'each') + (note ? ' – ' + note : '');
    }
    return '<div class="lgb-adds__row' + (folded ? ' lgb-adds__fold' : '') + '" data-row="' + r.key + '"' +
        (r.qty ? ' data-unit="' + variant.price + '"' : '') + '>' +
      '<input type="checkbox" id="lgbAdds_' + r.key + '">' +
      '<label class="lgb-adds__label" for="lgbAdds_' + r.key + '">' + title +
        (r.tag ? '<span class="lgb-adds__tag">' + r.tag + '</span>' : '') +
        '<span class="lgb-adds__note">' + note + '</span>' +
      '</label>' + picker +
      '<span class="lgb-adds__price">+' + money(variant.price * q) + '</span>' +
    '</div>';
  }

  function build(size, picks) {
    var wrap = document.createElement('div');
    wrap.className = 'lgb-adds' + (expanded ? ' is-open' : '');
    wrap.id = 'lgbAddons';

    var shown = 0, hidden = 0;
    var html = '<div class="lgb-adds__head">' + (CFG.heading || 'Finish it properly') + '</div>';

    CFG.rows.forEach(function (r) {
      if (!picks[r.key]) return;
      var folded = shown >= VISIBLE;
      if (folded) hidden++; else shown++;
      html += rowHtml(r, picks[r.key], size, folded);
    });

    if (hidden > 0) {
      html += '<button type="button" class="lgb-adds__more" id="lgbAddsMore">' +
        '<span class="lgb-adds__more-open">' + hidden + ' more option' + (hidden > 1 ? 's' : '') + '</span>' +
        '<span class="lgb-adds__more-close">Show fewer</span>' +
      '</button>';
    }
    html += '<div class="lgb-adds__status" id="lgbAddsStatus"></div>';
    wrap.innerHTML = html;

    wrap.addEventListener('change', function (e) {
      var row = e.target.closest ? e.target.closest('.lgb-adds__row') : null;
      if (!row) return;
      var pk = e.target.getAttribute && e.target.getAttribute('data-pick');
      if (pk && cands[pk]) {
        selVar[pk] = e.target.value;
        var pv = null;
        cands[pk].list.forEach(function (v) { if (String(v.id) === String(e.target.value)) pv = v; });
        if (pv) {
          wrap.dataset[pk] = pv.id;
          var prow = null;
          CFG.rows.forEach(function (x) { if (x.key === pk) prow = x; });
          var pq = prow ? qtyOf(prow) : 1;
          if (prow && prow.qty) row.setAttribute('data-unit', pv.price);
          var pp = row.querySelector('.lgb-adds__price');
          if (pp) pp.textContent = '+' + money(pv.price * pq);
        }
        var pcb = row.querySelector('input[type="checkbox"]');
        if (pcb && !pcb.checked) pcb.checked = true;
        row.classList.toggle('is-on', !!(pcb && pcb.checked));
        return;
      }
      var qk = e.target.getAttribute && e.target.getAttribute('data-qty');
      if (qk) {
        qtys[qk] = parseInt(e.target.value, 10) || 1;
        var unit = parseInt(row.getAttribute('data-unit'), 10) || 0;
        var pr = row.querySelector('.lgb-adds__price');
        if (pr) pr.textContent = '+' + money(unit * qtys[qk]);
        var cb = row.querySelector('input[type="checkbox"]');
        if (cb && !cb.checked) { cb.checked = true; }
        row.classList.toggle('is-on', !!(cb && cb.checked));
        return;
      }
      row.classList.toggle('is-on', e.target.checked);
    });

    wrap.addEventListener('click', function (e) {
      var more = e.target.closest ? e.target.closest('#lgbAddsMore') : null;
      if (!more) return;
      e.preventDefault();
      expanded = !expanded;
      wrap.classList.toggle('is-open', expanded);
    });
    return wrap;
  }

  function render() {
    var f = mainForm();
    if (!f || !product) return;
    var size = currentSize();

    var picks = {}, any = false;
    CFG.rows.forEach(function (r) {
      var v = matchFor(acc[r.key], size, r);
      if (v) { picks[r.key] = v; any = true; }
    });
    CFG.rows.forEach(function (r) {
      if (r.unless && picks[r.unless] && picks[r.key]) delete picks[r.key];
    });

    var existing = document.getElementById('lgbAddons');
    var key = [size].concat(CFG.rows.map(function (r) {
      if (r.pick && picks[r.key] && cands[r.key]) return cands[r.key].list.map(function (v) { return v.id; }).join(',');
      return picks[r.key] ? picks[r.key].id : '';
    })).join('|');

    if (!any) {
      if (existing) existing.remove();
      lastKey = null;
      return;
    }
    if (existing && key === lastKey && f.contains(existing)) return;

    var wasTicked = {};
    if (existing) {
      CFG.rows.forEach(function (r) {
        var cb = existing.querySelector('#lgbAdds_' + r.key);
        wasTicked[r.key] = !!(cb && cb.checked);
      });
      existing.remove();
    }

    var box = build(size, picks);
    CFG.rows.forEach(function (r) {
      var cb = box.querySelector('#lgbAdds_' + r.key);
      if (cb && wasTicked[r.key]) {
        cb.checked = true;
        cb.closest('.lgb-adds__row').classList.add('is-on');
        if (cb.closest('.lgb-adds__fold') && !expanded) {
          expanded = true;
          box.classList.add('is-open');
        }
      }
      box.dataset[r.key] = picks[r.key] ? picks[r.key].id : '';
    });

    var buttons = f.querySelector('.product-form-buttons');
    if (buttons && buttons.parentNode) buttons.parentNode.insertBefore(box, buttons);
    else f.appendChild(box);
    lastKey = key;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[name="add"]') : null;
    if (!btn) return;
    var box = document.getElementById('lgbAddons');
    if (!box) return;

    var extras = [];
    CFG.rows.forEach(function (r) {
      var cb = box.querySelector('#lgbAdds_' + r.key);
      if (cb && cb.checked && box.dataset[r.key]) {
        extras.push({ id: Number(box.dataset[r.key]), q: qtyOf(r) });
      }
    });
    if (!extras.length) return;

    var f = btn.closest('form[data-type="add-to-cart-form"]') || mainForm();
    var inp = idInputOf(f);
    if (!inp || !inp.value) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    busy = true;

    var status = document.getElementById('lgbAddsStatus');
    var original = btn.innerHTML;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    if (status) { status.textContent = ''; status.className = 'lgb-adds__status'; }

    var qtyInput = f.querySelector('[name="quantity"]');
    var n = qtyInput && parseInt(qtyInput.value, 10) > 0 ? parseInt(qtyInput.value, 10) : 1;

    var items = [{ id: Number(inp.value), quantity: n }];
    extras.forEach(function (x) { items.push({ id: x.id, quantity: x.q * n }); });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (er) { throw new Error(er.description || 'Could not add to basket'); });
      return r.json();
    }).then(function () {
      window.location.href = '/cart';
    }).catch(function (err) {
      busy = false;
      btn.disabled = false;
      btn.innerHTML = original;
      if (status) {
        status.textContent = (err && err.message) ? err.message : 'Sorry, something went wrong — please try again.';
        status.className = 'lgb-adds__status err';
      }
    });
  }, true);

  function load(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function start() {
    var rows = CFG.rows;
    Promise.all([load(CFG.productHandle)].concat(rows.map(function (r) { return load(r.handle); })))
      .then(function (res) {
        product = res[0];
        rows.forEach(function (r, i) { acc[r.key] = res[i + 1]; });
        if (!product) return;
        render();
        setInterval(render, 400);
      }).catch(function (err) {
        console.warn('LGB add-ons unavailable:', err);
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
